module.exports = __webpack_public_path__ + "img/g3.9e172a1c.png";